

// components/MenuItemsTable/MobileCartDrawer.js
import React from 'react';
import { ShoppingCart, DeleteOutline, Close } from '@mui/icons-material';
import CartItemsList from './CartItemsList';
import PriceSummary from './PriceSummary';
import PaymentOptions from './PaymentOptions';

const MobileCartDrawer = ({
  isOpen,
  onClose,
  cartItems,
  quantities,
  cartItemsCount,
  onClearCart,
  onDecrementQuantity,
  onIncrementQuantity,
  subTotal,
  gstTotal,
  platformCharges,
  packingCharges,
  deliveryCharges,
  discountAmount,
  grandTotal,
  appliedCoupon,
  onRemoveCoupon,
  onApplyCoupon,
  orderType,
  setOrderType,
  selectedAddressObj,
  onShowAddressPopup,
  showPaymentOptions,
  setShowPaymentOptions,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  selectedwalletTypes,
  setSelectedwalletTypes,
  onPlaceOrder,
  orderPlacing,
  onOpenScheduleModal,
  availableBalance,
  availableSelf,
  availableCompany,
  availableCashback,
  onShowGST
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1000,
          animation: 'fadeIn 0.3s ease'
        }}
      />

      {/* Drawer */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: '85%',
          maxWidth: '352px',
          backgroundColor: '#fafafa',
          zIndex: 1001,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
          animation: 'slideInRight 0.3s ease',
          overflow: 'hidden'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '16px 20px',
          backgroundColor: '#ee6521',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <ShoppingCart style={{ fontSize: '22px' }} />
            <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Your Cart</span>
            <span style={{ background: 'rgba(255,255,255,0.25)', padding: '2px 10px', borderRadius: '20px', fontSize: '12px' }}>
              {cartItemsCount} items
            </span>
          </div>
          {cartItems.length > 0 && (
            <button
              onClick={onClearCart}
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                color: '#fff',
                cursor: 'pointer',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
              }}
            >
              <DeleteOutline style={{ fontSize: '16px' }} /> Clear
            </button>
          )}
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: '#fff',
              cursor: 'pointer',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Close style={{ fontSize: '20px' }} />
          </button>
        </div>

        {/* Scrollable Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
          {cartItems.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#bbb' }}>
              <ShoppingCart style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.4 }} />
              <p style={{ margin: 0, fontWeight: '500' }}>Your cart is empty</p>
              <p style={{ margin: '8px 0 0', fontSize: '13px' }}>Add items from the menu</p>
            </div>
          ) : (
            <>
              <CartItemsList
                cartItems={cartItems}
                quantities={quantities}
                onDecrement={onDecrementQuantity}
                onIncrement={onIncrementQuantity}
              />
              
              <PriceSummary
                subTotal={subTotal}
                gstTotal={gstTotal}
                platformCharges={platformCharges}
                packingCharges={packingCharges}
                deliveryCharges={deliveryCharges}
                discountAmount={discountAmount}
                grandTotal={grandTotal}
                appliedCoupon={appliedCoupon}
                onRemoveCoupon={onRemoveCoupon}
                onApplyCoupon={onApplyCoupon}
                onShowGST={onShowGST}
              />
              
              <PaymentOptions
                orderType={orderType}
                setOrderType={setOrderType}
                selectedAddressObj={selectedAddressObj}
                onShowAddressPopup={onShowAddressPopup}
                showPaymentOptions={showPaymentOptions}
                setShowPaymentOptions={setShowPaymentOptions}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
                selectedwalletTypes={selectedwalletTypes}
                setSelectedwalletTypes={setSelectedwalletTypes}
                onPlaceOrder={onPlaceOrder}
                orderPlacing={orderPlacing}
                onOpenScheduleModal={onOpenScheduleModal}
                availableBalance={availableBalance}
                availableSelf={availableSelf}
                availableCompany={availableCompany}
                availableCashback={availableCashback}
              />
            </>
          )}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </>
  );
};

export default MobileCartDrawer;